module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-4b3c1b04cbc004921dd5b0a094941987.png";